function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWordpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 291.282 291.282",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D54E21"
    },
    d: "M0.013,145.641c0,57.627,33.502,107.479,82.088,131.039L12.63,86.358 C4.537,104.483,0.013,124.512,0.013,145.641z M243.974,138.285c0-17.998-6.482-30.479-12.017-40.166 c-7.374-11.999-14.284-22.149-14.284-34.157c0-13.392,10.123-25.845,24.471-25.845l1.866,0.127C218.101,14.511,183.58,0,145.672,0 C95.656,0,51.558,25.226,25.348,63.626c10.943,0.209,46.83,0.337,46.83,0.337c7.829-0.437,8.758,11.07,0.91,12.017 c0,0-7.875,0.919-16.66,1.384l53.047,157.74l31.872-95.58l-22.705-62.16c-7.838-0.473-15.267-1.384-15.267-1.384 c-7.857-0.473-6.928-12.454,0.938-12.017h77.181c7.82-0.437,8.758,11.07,0.91,12.017c0,0-7.875,0.919-16.66,1.384l52.638,156.529 l14.539-48.505C240.269,166.443,243.974,150.758,243.974,138.285z M148.221,158.386l-43.716,126.979 c13.046,3.842,26.829,5.917,41.158,5.917c16.942,0,33.219-2.931,48.359-8.266l-1.029-1.994L148.221,158.386z M273.443,75.752 c0.637,4.661,1.001,9.632,1.001,15.003c0,14.766-2.777,31.371-11.097,52.155l-44.472,128.599 c43.288-25.226,72.393-72.138,72.393-125.868C291.277,120.315,284.813,96.509,273.443,75.752z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordpress);
export default __webpack_public_path__ + "static/media/wordpress.014b1dd1866f2bf721bc89103582800b.svg";
export { ForwardRef as ReactComponent };